const POSITION = [
  'insideTop',
  'outside',
  'inside',
  'insideBottom',
]


const getRectRange = (points) => {
  const xValues = []
  const yValues = []
  for (let i = 0, len = points.length; i < len; i++) {
    const point = points[i]
    xValues.push(point.x)
    yValues.push(point.y)
  }
  const xMin = Math.min.apply(null, xValues)
  const yMin = Math.min.apply(null, yValues)
  const xMax = Math.max.apply(null, xValues)
  const yMax = Math.max.apply(null, yValues)

  return {
    x: xMin,
    y: yMin,
    width: xMax - xMin,
    height: yMax - yMin
  }
}

const getLabelPosition = (points, position, fontSize = 12) => {
  switch (position) {
    case 'insideTop':
      return points[1].y + (fontSize / 2)
    case 'inside':
      return ((points[0].y + points[1].y) / 2)// + (fontSize / 2)
    case 'insideBottom':
      return points[0].y - (fontSize / 2)
    default:
      return points[1].y - (fontSize / 2)
  }
}

export default (F2) => {
  const { Shape, Util } = F2

  Shape.registerShape('interval', 'valueLabel', {
    draw(cfg, container) {
      const parent = container.get('parent')
      let labelContainer = parent.get('labelContainer')

      if (!labelContainer) {
        labelContainer = parent.addGroup({
          zIndex: 10,
        })
        parent.set('labelContainer', labelContainer)
      }
      const points = this.parsePoints(cfg.points)
      // points 顶点的顺序
      // 1 ---- 2
      // |      |
      // 0 ---- 3
      const style = {
        fill: cfg.color
      }
      const origin = cfg.origin._origin  // 获取对应的原始数据记录

      const labelConfig = origin.labelStyle
      const format = origin.formatFn

      const position = POSITION.includes(labelConfig.position) ? labelConfig.position : 'outside'

      const rectCfg = getRectRange(points)

      const intervalShape = container.addShape('rect', {
        className: 'interval',
        attrs: Util.mix(rectCfg, style)
      })
      const y = getLabelPosition(points, position, labelConfig.fontSize)

      const textShape = labelContainer.addShape('text', {
        zIndex: 1,
        className: 'bar-value-label',
        attrs: {
          x: (points[1].x + points[2].x) / 2,
          y,
          text: format(origin),
          fill: '#808080',
          textAlign: 'center',
          textBaseline: 'middle',
          fontSize: labelConfig.fontSize || 12,
        }
      })
      container.sort()
      parent.sort()
      return [intervalShape, textShape]
    }
  })
}
